export default {
    Cliente_ID: 1,
    Sistema_ID: 1,
    strTicket: '999000000001000140',
    Session_ID: 'JBWEBETICKET_1',
    chrSerial: '999000000001'
  }


// WEBPACK FOOTER //
// ./src/mocking/detalhe-aposta-payload.js